(function () {
  'use strict';

  var CART_MUTATION_PATTERNS = [
    /\/cart\/add/,
    /\/cart\/change/,
    /\/cart\/update/,
    /\/cart\/clear/
  ];

  function isCartMutationUrl(url) {
    if (!url) return false;

    var path = String(url);

    return CART_MUTATION_PATTERNS.some(function (pattern) {
      return pattern.test(path);
    });
  }

  function setBadgeCount(count) {
    document
      .querySelectorAll('[data-tusa-cart-count]')
      .forEach(function (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
      });

    document
      .querySelectorAll('[data-tusa-cart-icon]')
      .forEach(function (icon) {
        icon.setAttribute(
          'aria-label',
          'Cart, ' + count + (count === 1 ? ' item' : ' items')
        );
      });
  }

  var refreshInFlight = null;

  function refreshCartCount() {
    if (refreshInFlight) return refreshInFlight;

    refreshInFlight = fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setBadgeCount(cart.item_count);
        return cart;
      })
      .catch(function () {})
      .finally(function () {
        refreshInFlight = null;
      });

    return refreshInFlight;
  }

  function bindDawnPubSub() {
    if (
      typeof window.subscribe === 'function' &&
      window.PUB_SUB_EVENTS &&
      window.PUB_SUB_EVENTS.cartUpdate
    ) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        refreshCartCount();
      });

      return true;
    }

    return false;
  }

  if (!bindDawnPubSub()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!bindDawnPubSub()) {
        document.addEventListener('cart:update', function () {
          refreshCartCount();
        });
      }
    });
  }

  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;

    var promise = nativeFetch.apply(this, arguments);

    if (isCartMutationUrl(url)) {
      promise
        .then(function (response) {
          if (response && response.ok) {
            refreshCartCount();
          }

          return response;
        })
        .catch(function () {});
    }

    return promise;
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form && form.action && isCartMutationUrl(form.action)) {
      window.setTimeout(refreshCartCount, 400);
    }
  });

  window.tusaRefreshCartCount = refreshCartCount;

  function initNavbar(navbar) {
    var searchToggle = navbar.querySelector('[data-tusa-search-toggle]');
    var searchDrawer = navbar.querySelector('[data-tusa-search-drawer]');
    var searchPanel =
      searchDrawer && searchDrawer.querySelector('.tusa-search-panel');
    var menuToggle = navbar.querySelector('[data-tusa-menu-toggle]');
    var mobileNav = navbar.querySelector('[data-tusa-mobile-nav]');

    function closeSearch() {
      if (!searchDrawer || !searchToggle) {
        return;
      }

      searchDrawer.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    }

    function openSearch() {
      if (!searchDrawer || !searchToggle) {
        return;
      }

      searchDrawer.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');

      var input = searchDrawer.querySelector('input[type="search"]');

      if (input) {
        window.requestAnimationFrame(function () {
          input.focus();
        });
      }
    }

    function closeMobileNav() {
      if (!mobileNav || !menuToggle) {
        return;
      }

      mobileNav.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    function openMobileNav() {
      if (!mobileNav || !menuToggle) {
        return;
      }

      mobileNav.hidden = false;
      menuToggle.setAttribute('aria-expanded', 'true');
    }

    if (searchToggle && searchDrawer) {
      searchToggle.addEventListener('click', function (event) {
        event.stopPropagation();

        var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';

        closeMobileNav();

        if (isOpen) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    }

    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function (event) {
        event.stopPropagation();

        var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';

        closeSearch();

        if (isOpen) {
          closeMobileNav();
        } else {
          openMobileNav();
        }
      });
    }

    if (searchDrawer) {
      searchDrawer.addEventListener('click', function (event) {
        if (searchPanel && searchPanel.contains(event.target)) {
          event.stopPropagation();
        }
      });
    }

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;

        if (searchDrawer && !searchDrawer.hidden) {
          var clickedInsideSearch = searchPanel && searchPanel.contains(target);
          var clickedSearchToggle = searchToggle && searchToggle.contains(target);

          if (!clickedInsideSearch && !clickedSearchToggle) {
            closeSearch();
          }
        }

        if (mobileNav && !mobileNav.hidden && !navbar.contains(target)) {
          closeMobileNav();
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearch();
        closeMobileNav();
      }
    });

    var dropdownItems = navbar.querySelectorAll(
      '.tusa-navbar__nav-item--has-dropdown'
    );

    var backdrop = navbar.querySelector('[data-tusa-backdrop]');

    function syncBackdrop() {
      var anyOpen = Array.prototype.some.call(dropdownItems, function (el) {
        return el.classList.contains('is-open');
      });

      navbar.classList.toggle('has-open-dropdown', anyOpen);
      document.body.classList.toggle('tusa-menu-open', anyOpen);
    }

    dropdownItems.forEach(function (item) {
      var link = item.querySelector(':scope > .tusa-navbar__nav-link');
      var closeTimer;

      function openItem() {
        clearTimeout(closeTimer);
        item.classList.add('is-open');

        if (link) {
          link.setAttribute('aria-expanded', 'true');
        }

        syncBackdrop();
      }

      function scheduleClose() {
        clearTimeout(closeTimer);

        closeTimer = window.setTimeout(function () {
          item.classList.remove('is-open');

          if (link) {
            link.setAttribute('aria-expanded', 'false');
          }

          syncBackdrop();
        }, 250);
      }

      item.addEventListener('mouseenter', openItem);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', openItem);

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) {
          scheduleClose();
        }
      });

      if (backdrop) {
        backdrop.addEventListener('mouseenter', function () {
          item.classList.remove('is-open');

          if (link) {
            link.setAttribute('aria-expanded', 'false');
          }

          syncBackdrop();
        });
      }
    });

    navbar.querySelectorAll('[data-tusa-mega]').forEach(function (mega) {
      var tabs = mega.querySelectorAll('[data-tusa-mega-tab]');
      var panels = mega.querySelectorAll('[data-tusa-mega-panel]');

      function activateTab(tab) {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var targetId = tab.getAttribute('data-mega-panel');
        var target = mega.querySelector('#' + targetId);

        if (target) {
          target.classList.add('is-active');
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab);
        });

        tab.addEventListener('mouseenter', function () {
          activateTab(tab);
        });
      });
    });
  }

  document.querySelectorAll('.tusa-navbar').forEach(initNavbar);
})();